import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { Country } from "./Country";
export class BankDetails {
  constructor() {
    _defineProperty(this, "BankDetailsCountryID", {
      key: 'BankDetailsCountry',
      fieldName: 'country_id',
      fieldTitle: 'Country Id',
      content: null
    });
    _defineProperty(this, "BankDetailsCountry", {
      key: 'BankDetailsCountry',
      fieldName: 'bank_details_country',
      fieldTitle: 'global_text.payment_fields.bank_details.country',
      model: Country,
      content: null
    });
    _defineProperty(this, "BankDetailsUserID", {
      key: 'BankDetailsUserID',
      fieldName: 'user_id',
      fieldTitle: 'User Id',
      content: null
    });
    _defineProperty(this, "BankDetailsBeneficiaryName", {
      key: 'BankDetailsBeneficiaryName',
      fieldName: 'bank_detail_beneficiary_name',
      fieldTitle: 'global_text.payment_fields.bank_details.beneficiary_name',
      content: null
    });
    _defineProperty(this, "BankDetailsName", {
      key: 'BankDetailsName',
      fieldName: 'bank_detail_name',
      fieldTitle: 'global_text.payment_fields.bank_details.bank_name',
      content: null
    });
    _defineProperty(this, "BankDetailsAccountNumber", {
      key: 'BankDetailsAccountNumber',
      fieldName: 'bank_detail_account_number',
      fieldTitle: 'global_text.payment_fields.bank_details.account_number',
      content: null
    });
    _defineProperty(this, "BankDetailsSwiftCode", {
      key: 'BankDetailsSwiftCode',
      fieldName: 'bank_detail_swift_code',
      fieldTitle: 'global_text.payment_fields.bank_details.swift_code',
      content: null
    });
    _defineProperty(this, "BankDetailsAddress", {
      key: 'BankDetailsAddress',
      fieldName: 'bank_detail_address',
      fieldTitle: 'global_text.payment_fields.bank_details.address',
      content: null
    });
  }
}
export default BankDetails;